import axios from 'axios';

const backendUrl =
  (process.env.REACT_APP_BACKEND_URL || '').trim() ||
  'https://api.vertecotech.com';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || `${backendUrl}/api`,
  timeout: 30000000,
});

/* =======================
   REQUEST → adiciona token
======================= */
api.interceptors.request.use(
  (config) => {
    let token = sessionStorage.getItem('Authorization');

    if (!token) {
      token = localStorage.getItem('access_token');
    }

    if (token?.startsWith('Bearer ')) {
      token = token.replace('Bearer ', '');
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =======================
   RESPONSE → trata erros
======================= */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';

    const publicEndpoints = ['/login', '/password-reset', '/password-reset-confirm', '/signup', '/delete-user-request', '/fale-conosco/'];
    if (publicEndpoints.some((ep) => url.includes(ep))) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      sessionStorage.removeItem('Authorization');
      localStorage.removeItem('access_token');

      // evita loop infinito
      const publicPaths = ['/', '/login', '/register', '/certificado', '/old_landing_page'];
      const path = window.location.pathname;
      if (!publicPaths.includes(path) && !path.startsWith('/privacy') && !path.startsWith('/terms')) {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
